/**
 * Opens the contact email in the default mail client.
 * No-op when run outside a browser (e.g. SSR).
 */
export function openContactEmail(): void {
  if (typeof window === "undefined") return
  window.open("mailto:hi@giulio.me", "_blank", "noopener,noreferrer")
}

/**
 * Opens the contact Telegram link in a new tab.
 * No-op when run outside a browser (e.g. SSR).
 */
export function openContactTelegram(): void {
  if (typeof window === "undefined") return
  window.open("https://t.me/this_is_giulio", "_blank", "noopener,noreferrer")
}
